/** Keep Shopify's real localization navigation, but do not replay the hero
 * opening sequence when it returns to the same page in a different locale.
 * No extra fetches, copied DOM, translated-price cache or submission delay.
 */
const key = 'bardem:localization-navigation';
let exitTimer;
document.addEventListener('submit', event => {
  const form = event.target;
  if (event.defaultPrevented || !(form instanceof HTMLFormElement) ||
      form.querySelector('[name="form_type"]')?.value !== 'localization' || window.Shopify?.designMode) return;
  const values = new FormData(form);
  if (event.submitter?.name) values.set(event.submitter.name, event.submitter.value);
  const root = document.documentElement;
  // Remember only the control explicitly chosen. A hidden counterpart is not a choice.
  if (!form.hasAttribute('data-localization-automatic')) {
    root.setAttribute('data-localization-manual-choice', '');
    try {
      const preferenceKey = 'bardem:localization-preferences:v1';
      const saved = JSON.parse(localStorage.getItem(preferenceKey) || 'null');
      const preferences = saved && Number.isFinite(saved.time) && Date.now() - saved.time >= 0 &&
        Date.now() - saved.time < 180 * 24 * 60 * 60 * 1000 ? saved : {};
      const language = values.get('language_code');
      const country = values.get('country_code');
      const scope = form.dataset.localizationChoice;
      if (typeof language === 'string' &&
          (scope === 'both' || scope === 'language' || (!scope && language !== root.dataset.localizationLanguage))) {
        preferences.language = language;
      }
      if (typeof country === 'string' &&
          (scope === 'both' || scope === 'country' || (!scope && country !== root.dataset.localizationCountry))) {
        preferences.country = country;
      }
      preferences.time = Date.now();
      localStorage.setItem(preferenceKey, JSON.stringify(preferences));
    } catch { /* Shopify still persists the actual choice via its native POST. */ }
    try {
      sessionStorage.setItem('bardem:localization-initialized:v1', 'true');
    } catch { /* Automatic redirection also fails open when session storage is blocked. */ }
  }
  try {
    sessionStorage.setItem(key, JSON.stringify({
      page: root.dataset.localizationPage,
      language: values.get('language_code') || root.dataset.localizationLanguage,
      country: values.get('country_code') || root.dataset.localizationCountry,
      time: Date.now(),
    }));
  } catch { /* Native navigation is still available without session storage. */ }
  root.setAttribute('data-localization-leaving', '');
  clearTimeout(exitTimer);
  exitTimer = setTimeout(() => root.removeAttribute('data-localization-leaving'), 1200);
  // Do not preventDefault or submit again: retain Shopify's form fields,
  // localized redirect, checkout cookies and the clicked submit button.
});

window.addEventListener('pageshow', () => {
  clearTimeout(exitTimer);
  document.documentElement.removeAttribute('data-localization-leaving');
});
